import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500 py-3 flex-wrap">
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-2">
          {idx > 0 && (
            <span className="text-foreground-300">/</span>
          )}
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}